import React, { useEffect, useState, useRef } from "react";
import { useTheme } from "../../hooks/useTheme";
import CustomChannel from "./components/CustomChannel";
import CustomMessageList from "./components/CustomMessageList";
import MessagePageTopBar from "./components/MessagePageTopBar";
import CustomMessageInput from "./components/CustomMessageInput";
import { useTextSearch } from "../../hooks/useTextSearch";
import DialogSendWallet from "./components/DialogSendWallet";
import { SendTransactionStateRecipient } from "./wallet/SendTransaction";
import { useParams } from "react-router-dom";

interface MessagePageProps {}

export const MessagePage: React.FC<MessagePageProps> = () => {
    const {isMobile} = useTheme();
    const { isTextInputFocused } = useTextSearch();
    const [isDialogSendWalletOpen, setIsDialogSendWalletOpen] = useState(false);
    const [transactionRecipient, setTransactionRecipient] = useState<SendTransactionStateRecipient | undefined>(undefined);
    const [dialogPosition, setDialogPosition] = useState({ top: 0, right: 0 });
    const messageListRef = useRef<HTMLDivElement>(null);
    const { type, id } = useParams();

    useEffect(() => {
        setIsDialogSendWalletOpen(false);
        setTransactionRecipient(undefined);
    }, [type, id]);

    const handleOpenDialog = (data: SendTransactionStateRecipient) => {
        if(transactionRecipient === undefined) {
            setTransactionRecipient(data);
        }

        // Get the position of the message list
        if (messageListRef.current) {
            const rect = messageListRef.current.getBoundingClientRect();
            // Center the dialog in the message list
            setDialogPosition({
                top: rect.top,
                right: window.innerWidth - rect.right
            });
        }

        setIsDialogSendWalletOpen(!isDialogSendWalletOpen);
    };

    return (
        <CustomChannel>
            <MessagePageTopBar
                onClickSend={handleOpenDialog}
            >
                <div ref={messageListRef} className="flex-grow overflow-y-hidden relative">
                    <CustomMessageList />
                    <DialogSendWallet 
                        visible={isDialogSendWalletOpen}
                        recipient={transactionRecipient}
                        onClose={() => setIsDialogSendWalletOpen(false)}
                        position={dialogPosition}
                    />
                </div>
                <div className={
                    `border-t border-brand-border-color flex grow-0 shrink-0 bg-brand-bg-4
                    ${isMobile ? 'pb-[15px] min-h-[70px]' : 'min-h-[60px]'}
                    `
                }>
                    <CustomMessageInput 
                        shouldFocus={! isTextInputFocused}
                    />
                </div>
            </MessagePageTopBar>
        </CustomChannel>
    );
};

export default MessagePage;